module.exports = __webpack_public_path__ + "img/40_24.1de76dba.png";